import React, { useState, useRef } from "react";
import backgroundImage from "~/images/modal-background-image.png";
import { Close } from "@mui/icons-material";
import { buttonClass } from "../../utils/Buttons";
import useOutsideClick from "../../Hooks/useOutsideClick";
import ProfileCard from "../../ProfileCard";

const ModalUserDelete = ({ user, entity, organization_id, closeModal, setUsers, setNotice }) => {
  const [submitting, setSubmitting] = useState(false);

  const modalRef = useRef(null);
  useOutsideClick(modalRef, closeModal);

  const isDisabled = () => {
    return submitting;
  };

  const deleteUser = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);

    try {
      const response = await fetch(
        `/organization/${organization_id}/entities/${entity.id}/users/${user.id}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": document
              .querySelector('meta[name="csrf-token"]')
              .getAttribute("content"),
          },
        }
      );

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error);
      }

      setNotice({ kind: "success", open: true, message: "User access successfully revoked." });
      setUsers((prev) => prev.filter((u) => u.id != user.id));
      closeModal();
    } catch (error) {
      setNotice({ kind: "error", open: true, message: error.message || "There was an error." });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={backgroundImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={closeModal}>
            <Close />
          </div>
        </div>
        <form onSubmit={deleteUser}>
          <div className="tpa-modal__body">
            <div className="flex flex-column gap--16">
              <div className="t--xl t--500">Revoke User Access?</div>
              <div className="t--subtitle">
                This will remove the user's access to this covered entity account.
              </div>
              <ProfileCard
                initials={user.initials}
                title={user.name}
                subtitle={user.email}
                iconColor="light-blue"
              />
            </div>
            <div className="flex flex-column gap--16">
              <div className="t--16 t--500">
                Revoking user access to the following Covered Entity:
              </div>
              <ProfileCard
                initials={entity.entity_name[0]}
                title={entity.entity_name}
                subtitle={entity.id_340b}
              />
            </div>
            <div className="flex justify-content-end gap--16">
              <button className="button button--white t--500" onClick={closeModal}>
                Cancel
              </button>
              <button type="submit" className={buttonClass(isDisabled())} disabled={isDisabled()}>
                Revoke Access
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalUserDelete;
